import { appManager } from "../AppManager";
import { Log, UserManager } from "oidc-client-ts";
export class Authenticator {
    constructor(config) {
        this.events = {};
        this.config = config;
        Log.setLogger(console);
        this.userManager = new UserManager(config);
        this.userManager.events.addUserSignedOut(() => {
            this.raise("user-signedout");
        });
        this.userManager.events.addUserSignedIn(() => {
            this.raise("user-signedin");
        });
        this.userManager.events.addSilentRenewError(async () => {
            await this.logout();
            // when access token could not be renewed, redirect to home.
            window.location.href = `${appManager.RootUrl}`;
        });
    }
    on(event, callback) {
        if (typeof this.events[event] === "undefined")
            this.events[event] = [];
        this.events[event].push(callback);
    }
    raise(event) {
        if (typeof this.events[event] === "undefined")
            return;
        this.events[event].forEach(callback => {
            callback();
        });
    }
    async isTokenExpired() {
        const user = await this.userManager.getUser();
        // if logged out, token cannot be experired.
        if (typeof user === "undefined")
            return;
        if (user == null)
            return;
        return user.expired;
    }
    async getUser() {
        const user = await this.userManager.getUser();
        // if logged out, token cannot be experired.
        if (typeof user === "undefined")
            return undefined;
        if (user == null)
            return undefined;
        if (user.expired)
            return undefined;
        return user;
    }
    async getUserDetails() {
        const signedIn = await this.trySilentSignin();
        if (!signedIn)
            return undefined;
        const userFromOAuth = await this.getUser();
        const accessToken = await this.getAccessToken();
        return await appManager.api.identity.getUser({
            accessToken: accessToken,
            id: userFromOAuth.profile.sub
        });
    }
    async getAccessToken() {
        const user = await this.getUser();
        if (user.expired)
            throw new Error("Access token expired.");
        return user.access_token;
    }
    async isSignedIn() {
        const user = await this.userManager.getUser();
        // if logged out, token cannot be experired.
        if (typeof user === "undefined")
            return false;
        if (user == null)
            return false;
        if (user.expired)
            return false;
        return true;
    }
    async startSignin(url) {
        const user = await this.userManager.getUser();
        if (!user || user.expired) {
            if (typeof (Storage) !== "undefined") {
                localStorage.setItem("redirect-url", url);
            }
            await this.userManager.signinRedirect({
                redirectMethod: "replace"
            });
            this.raise("login");
        }
    }
    async completeSignin() {
        await this.userManager.signinRedirectCallback();
        if (typeof (Storage) !== "undefined") {
            return localStorage.getItem("redirect-url");
        }
        return undefined;
    }
    async trySilentSignin() {
        try {
            let user = await this.getUser();
            if (!user || user.expired) {
                user = await this.userManager.signinSilent();
                return typeof user !== "undefined";
            }
            return true;
        }
        catch (e) {
            return false;
        }
    }
    async signinSilentCallback() {
        const user = await this.userManager.signinSilentCallback();
        return typeof user !== "undefined";
    }
    async logout() {
        await this.userManager.removeUser();
        this.raise("logout");
    }
}
